"use client";

import { RadioGroup } from "@headlessui/react";

import { Heading4 } from "@/components/text/Heading4";
import { SoftText } from "@/components/text/SoftText";
import { STEM_SPLIT_GROUP_OPTION_LABELS } from "@/constants/stemSplit";
import { StemSplitGroupType } from "@/types/defs/stemSplit";
import { classNames } from "@/utils/classNames";

export function SeparationTypeSelector({
  selectedVariant,
  onVariantChange,
}: {
  selectedVariant: StemSplitGroupType;
  onVariantChange: (variant: StemSplitGroupType) => void;
}) {
  return (
    <div className="space-y-4">
      <div>
        <Heading4 elementType="h4">Separation variant</Heading4>
        <SoftText elementType="p" className="mt-1">
          Choose how you want to split your audio. Each option creates different
          stem files that you can download separately.
        </SoftText>
      </div>
      <RadioGroup
        value={selectedVariant}
        onChange={onVariantChange}
        className="grid grid-cols-1 gap-3 sm:grid-cols-2"
      >
        <RadioGroup.Label className="sr-only">
          Separation variant
        </RadioGroup.Label>
        {STEM_SPLIT_GROUP_OPTION_LABELS.map((option) => (
          <RadioGroup.Option
            key={option.value}
            value={option.value}
            className={({ checked }) =>
              classNames(
                checked ?
                  "bg-primary text-white ring-2 ring-primary"
                : "bg-white text-gray-900 ring-1 ring-gray-300 hover:bg-gray-50",
                "flex cursor-pointer items-center justify-between rounded-xl p-4 shadow-sm transition-all duration-200 focus:outline-none"
              )
            }
          >
            {({ checked }) => (
              <>
                <div>
                  <RadioGroup.Label as="div" className="font-medium">
                    {option.title}
                  </RadioGroup.Label>
                  <RadioGroup.Description
                    as="div"
                    className="text-sm opacity-80"
                  >
                    {option.description}
                  </RadioGroup.Description>
                </div>
                <div
                  className={classNames(
                    checked ? "bg-white" : "bg-gray-200",
                    "min-w-5 min-h-5 h-5 w-5 rounded-full transition-colors duration-200"
                  )}
                >
                  {checked && (
                    <div className="m-1 h-3 w-3 rounded-full bg-primary" />
                  )}
                </div>
              </>
            )}
          </RadioGroup.Option>
        ))}
      </RadioGroup>
    </div>
  );
}
